/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./peopleBuy.vue?vue&type=template&id=1ec52848&scoped=true&"
import script from "./peopleBuy.vue?vue&type=script&lang=js&"
export * from "./peopleBuy.vue?vue&type=script&lang=js&"
import style0 from "./peopleBuy.vue?vue&type=style&index=0&id=1ec52848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec52848",
  null
  
)

export default component.exports